/**
 * Component: Overlay
 * Both overlay and backdrop
 */


var dnDepartments = dnDepartments || {};

dnDepartments.overlay = dnDepartments.overlay || function () {

    this.backdrop = function() {
        if ($('#js-overlay-backdrop').length !== 1) {
            // Fade in overlay effect
            $('body').append('<div id="js-overlay-backdrop"></div>');
            $('#js-overlay-backdrop').height($('body').height());

            $('#js-overlay-backdrop').on('click', function(){
                destroy();
            });
        }
    };

    this.destroy = function() {
        if ($('#js-overlay-backdrop').length === 1) {

            // Remove all js-active elements
            $('.js-active').removeClass('js-active');

            // FIX LATER
            if ($('body').hasClass('mobile-nav-open')) {
                $('body').removeClass('mobile-nav-open');
            }

            $('#js-overlay-backdrop').remove();
        }
    };

    return {
        backdrop : backdrop,
        destroy : destroy
    };
}();
